import { useSelector } from 'react-redux';

import { CurrentUserState } from 'dashboard/redux/reducers/current-user';
import { RootState } from 'dashboard/redux/store';
import { LocalStorageKey } from 'lib/clients/StorageClient';
import useLocalStorage from 'lib/hooks/useLocalStorage';

/**
 * @name `useIsITEInternal`
 *
 * A hook that returns whether the current user should have internal
 * fully-enabled editing capabilities for ITE. Piggybacks off of useIsPersonerd.
 *
 * Supports toggle internal features on and off via flag stored in localStorage.
 * Not intended for long term usage. Quick convenient interim workaround for
 * restricting features to internal-only while allowing manual e2e testing via the toggle.
 */
export default () => {
  const currentUser = useSelector<RootState, CurrentUserState>((state) => state.currentUser);
  const [internalEditingEnabled, _] = useLocalStorage<boolean>(
    LocalStorageKey.DashboardITEInternalEditingEnabled,
    true,
  );
  const isPersonerd =
    !!currentUser.impersonationMode ||
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    currentUser.currentUser.attributes['email-address'].endsWith('@withpersona.com');

  return isPersonerd && internalEditingEnabled;
};
